import { CoreMessages, PrimitiveType } from 'locale';
import { useIntlFormat as useIntlFormatCommon } from '@enterprise/common';

import enMessages from 'src/lang/compiled/en.intl.output.json';

export type UseIntlFormatFn = (key: CoreMessages, value?: Record<string, PrimitiveType>) => string;

export function useIntlFormat() {
  return useIntlFormatCommon(enMessages);
}
